module.exports = __webpack_public_path__ + "img/Cookie_1_resize_36.2cb74e8e.png";